import { useContext, useEffect } from "react";
import clsx from "clsx";
import { usePage } from "@tree-company/tree-query";
import { LocaleContext } from "../app";
import { Button } from "./button";
import { DEBUG } from "../debug";
import { usePageEffects } from "../hooks/use_page_effects";

export function OptinPage({
  className,
  page,
  children,
  handleSave,
  onPreviousPage,
}) {
  const { translate } = useContext(LocaleContext);
  const { title, htmlAttributes, key } = usePage(page);
  usePageEffects({ key });
  const handleSubmit = (e) => {
    if (!e.currentTarget.checkValidity()) {
      e.preventDefault();
      const firstInvalid = e.currentTarget.querySelector(":invalid");
      const target = firstInvalid?.closest(".optin-field") ?? firstInvalid;
      target?.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    handleSave(e);
  };

  // todo: remove before final release
  useEffect(() => {
    if (!DEBUG) return;
    const fakeValues = {
      "optin-bank": "yes",
      "optin-birth-year": 1990,
      "optin-gender": "x",
      "optin-postcode": 2000,
    };
    for (const section of page.sections) {
      if (section.value === null && fakeValues[section.key] !== null) {
        section.value = fakeValues[section.key];
      }
    }
  }, [page]);

  return (
    <form
      className={clsx(className, "page", "page--optin", htmlAttributes.class)}
      onSubmit={handleSubmit}
      noValidate
    >
      <div className="page__main">
        <div className="page-intro">
          {title && <h1 className="page__title">{title}</h1>}
          <p
            className="page__text"
            dangerouslySetInnerHTML={{ __html: translate("optin.body") }}
          ></p>
        </div>
        <div className="cards-wrapper">{children}</div>
      </div>
      <div className="page__actions">
        <Button
          variation="clear"
          className="page__action page__action--previous"
          onClick={onPreviousPage}
          iconPrev
          srText
        >
          {translate("navigation.previous")}
        </Button>
        <Button
          type="submit"
          variation="filled"
          className="page__action page__action--next"
        >
          {translate("navigation.next")}
        </Button>
      </div>
    </form>
  );
}
